// @ts-strict-ignore
import React, { useEffect } from 'react';
import Space from 'antd/lib/space';
import {
    AppComponentProps,
    QuickStartCISetupStep,
    QuickStartCISetupStepType,
    QuickStartCISetupViewProps,
} from '../../../typescriptHelpers';
import { ArrowRightOutlined } from '@ant-design/icons';
import Text from 'antd/lib/typography/Text';
import { QuestionsInfoSection } from '../QuestionsInfoSection';
import { antGrey } from '../../styles/globalStyles';
import { selectQuickStartCIStepData } from '../../../selectors/selectors';
import { useDispatch } from 'react-redux';
import { setQuickStartCIStepData } from '../../../actions/ui';

const SetupViewComponent: React.FC<QuickStartCISetupViewProps> = ({ appId }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(
            setQuickStartCIStepData({
                stepType: QuickStartCISetupStepType.WhatIsQuickStartCI,
                appId,
                data: {
                    visited: true,
                },
            }),
        );
    }, []);

    return (
        <Space direction="vertical">
            <Text
                style={{
                    color: antGrey.grey8,
                    fontSize: 20,
                }}
            >
                If you don’t yet have a CI/CD pipeline for your mobile app – or want to replace an existing flaky one –
                run this wizard to autogenerate an end-to-end build-and-deploy workflow for GitHub Actions (other
                providers coming soon!).
            </Text>
            <br />
            <Text
                style={{
                    color: antGrey.grey8,
                    fontSize: 24,
                    fontWeight: 600,
                }}
            >
                How does this work?
            </Text>
            <br />
            <Text
                style={{
                    color: antGrey.grey8,
                    fontSize: 20,
                }}
            >
                <ol>
                    <li>Runway connects to GitHub and App Store Connect or Play Console for you.</li>
                    <li>We pull together all the necessary configs by scanning your repo and querying the stores.</li>
                    <li>
                        Runway autogenerates everything you need – a <strong>GitHub Actions workflow file</strong>, a{' '}
                        <strong>fastlane Fastfile</strong>, and a <strong>Ruby Gemfile</strong> – and optionally opens a
                        PR adding all of these right into your repo, ready for use.
                    </li>
                    <li>That’s it! Head to GitHub Actions to trigger your new build-and-deploy workflow.</li>
                </ol>
            </Text>
            <br />
            <Text
                style={{
                    color: antGrey.grey8,
                    fontSize: 20,
                }}
            >
                Sound good? Hit <strong>‘Next’</strong> in the upper-right corner to get started.
            </Text>
        </Space>
    );
};

const InfoViewComponent: React.FC<AppComponentProps> = () => {
    return (
        <Space direction="vertical">
            <QuestionsInfoSection />
        </Space>
    );
};

export const WhatIsQuickStartCI: QuickStartCISetupStep = {
    icon: () => ArrowRightOutlined,
    headerTitle: 'What is Quickstart CI/CD?',
    SetupViewComponent,
    InfoViewComponent,
    isCompleteSelector: (state, { appId }) => {
        const stepData = selectQuickStartCIStepData(state, appId, QuickStartCISetupStepType.WhatIsQuickStartCI);
        return !!stepData?.visited;
    },
};
